import { FC } from "react";
import { Divider as ChakraDivider } from "@chakra-ui/react";

export const Divider: FC = () => {
  return (
    <ChakraDivider
      borderColor="th.cream3"
      display={{ base: "none", md: "initial" }}
      h="1px"
    />
  );
};
